import React, { useCallback } from 'react';
import ChatLauncher from './components/ChatLauncher';
import ChatWindow from './components/ChatWindow';
import { useChatInput } from './hooks/useChatInput';
import { useChatScroll } from './hooks/useChatScroll';
import { useChatSession } from './hooks/useChatSession';
import { useChatWindow } from './hooks/useChatWindow';
import { useEmbedSizing } from './hooks/useEmbedSizing';
import '../Chatbox.css';

const Chatbox = () => {
  const { messages, isLoading, showWelcome, sendMessage, resetConversation } = useChatSession();
  const scroll = useChatScroll(messages, isLoading);
  const input = useChatInput(isLoading, sendMessage);
  const { isOpen, open, close } = useChatWindow(input.focusInput);

  useEmbedSizing(isOpen);

  const handleReset = useCallback(
    (options) => {
      resetConversation({
        ...options,
        onAfterReset: () => {
          scroll.hideScrollButton();
          input.clearInput();
          input.focusInput();
          options?.onAfterReset?.();
        }
      });
    },
    [resetConversation, scroll, input]
  );

  return (
    <>
      {!isOpen && <ChatLauncher onOpen={open} />}
      {isOpen && (
        <ChatWindow
          onClose={close}
          onReset={handleReset}
          messages={messages}
          showWelcome={showWelcome}
          isLoading={isLoading}
          onSend={sendMessage}
          scroll={scroll}
          input={input}
        />
      )}
    </>
  );
};

export default Chatbox;
